import { Action, initialState, State } from "store/store";

export const setActiveTopic = (
  state: State = initialState,
  { data }: Action
): State => {
  return {
    ...state,
    currentTopic: data.id,
  };
};